exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2XokGPs7kbte1mH1qlpkzM .campaign-post-head{color:dycolor-internal(!head,@theme-very-dark-grey)}._2XokGPs7kbte1mH1qlpkzM .builder .left-content .box-widget-list-value .creative-input{background-color:dycolor-internal(!input-background,@theme-light-grey) !important}._2XokGPs7kbte1mH1qlpkzM #dropzone{background-color:dycolor-internal(!background,@theme-very-light-grey)}._2XokGPs7kbte1mH1qlpkzM .file-list .ghost{border:1px solid dycolor-internal(!drag-and-drop-ghost,@primary)}\n", ""]);

// exports
exports.locals = {
	"root": "_2XokGPs7kbte1mH1qlpkzM"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/adv-builder/AdvBuilder.scss
// module id = 879
// module chunks = 1